//import {FieldController} from "./elements.field.controller";

class sectionDesignerController {

    static get $inject(){ return  ['$element','$scope', 'DialogService'];}

    constructor($element, $scope, DialogService){
        this.dialogs = DialogService;
        this.$scope = $scope;

        this._fields = [];
        this.$scope.$on('onInitFields', this.onInitFields.bind(this));


    }

    $onInit(){
      //  console.log('on init ');
        if(!this.model || !this.model.length){
            this.AddEtap();
        }

        this.$scope.$on('before::save::other', this.onSaveForm.bind(this));
    }

    removeDesign(item){
        let indx = this.model.findIndex(v => v==item);
        this.dialogs.confirm('Удаление ','Вы уверены, Удалить?')
        .then(()=>this.model.splice(indx, indx >= 0 ? 1 : 0));
    }

    AddEtap(){
     //   console.log('addEtap');
      if(!this.model){
        this.model = [];
      }
      this.model.push({
         ID:'new',
         Stage:this.model.length+1
      })
    }


    onSaveForm(){
        
       

    }


    onInitFields(/*event, data*/){
    //  const fieldName  =data.name.replace('model.','');
    
    }


}

export {sectionDesignerController}


// WEBPACK FOOTER //
// ./src/components/elements/section.designer.module.js